<template>
  <div>
    <div style="width: 100%;text-align: right;margin-bottom: 20px">
      <Button type="success" @click="newIssue">New issue</Button>
    </div>
    <Alert v-for="item in issuesList" :key="item.id" show-icon>
      <template slot="icon">
        <open-issue />
      </template>
      <div class="issue-title">
        <a :href="'https://github.com' + item.url">{{item.title}}</a>
      </div>
      <template slot="desc">
        <div>
          opened on {{formatDate(item.submittime)}} by {{ item.submituser }}
        </div>
      </template>
    </Alert>
  </div>
</template>

<script>
// zhouhan@cibr.ac.cn 2023/3/30 16:20

import OpenIssue from "../icon/openIssue.vue";
import dayjs from "dayjs";

export default {
  name: "gitHubList",
  components: {OpenIssue},
  data() {
    return {
      loading: false,
      issuesList : []
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    newIssue(){
      window.open('https://github.com/azzhu/EasyFlyTracker/issues/new','_blank');
    },
    formatDate(val){
      return dayjs(val).format("YYYY-MM-DD HH:mm:ss");
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      this.$axios.post("/suggestion/github/initPage", {}).then((res) =>{
        this.issuesList = res.data.issuesList;
      }).catch(function (res) {
        console.log(res);
      });
    }
  }
}
</script>

<style scoped>
.issue-title{
  color: #1f2328;
  font-size: 16px;
  font-weight: bold;
}
</style>